import React, { PureComponent } from 'react';
import isNumber from 'lodash/isNumber';

import { Checkbox } from 'redpoints-front-components/index';

/**
 * GridCardFooter component
 * @example <GridCardFooter />
 */
class GridCardFooter extends PureComponent {
  /**
   * Function to set if scoring is negative or warning
   * @param scoring
   * @returns {string}
   */
  static checkValue = scoring => {
    if (scoring <= -1) {
      return 'info-text--negative';
    } else if (scoring > -1 && scoring <= 1) {
      return 'info-text--warning';
    }
    return '';
  };

  constructor(props) {
    super(props);
    this.state = {
      checked: false,
    };

    this.handleCheckbox = this.handleCheckbox.bind(this);
  }

  handleCheckbox() {
    const { checked } = this.state;
    const { item } = this.props;
    this.setState(
      {
        checked: !checked,
      },
      () => this.props.handleCheckBox(this.state.checked, item)
    );
  }

  render() {
    const { checked } = this.state;
    const { item } = this.props;
    return (
      <div
        onClick={this.handleCheckbox}
        className="rp-gc-footer-clickable-area"
      >
        {isNumber(item.scoring) ? (
          <div className="rp-gc-footer-info">
            <span
              className={`info-text ${GridCardFooter.checkValue(item.scoring)}`}
            >
              {item.scoring}
            </span>
          </div>
        ) : (
          ''
        )}
        <Checkbox checked={checked} />
      </div>
    );
  }
}

export default GridCardFooter;
